module.exports = __webpack_public_path__ + "img/甘松.5f4bfcc8.jpg";